import { TypeDefinition } from "../models/generic";

export class SEOPageType {
    public static Page: TypeDefinition = { id: 1, name: "Page" };
    public static Event: TypeDefinition = { id: 2, name: "Event" };
    public static CareerCenterJobPost: TypeDefinition = { id: 3, name: "CareerCenterJobPost" };
    public static CareerCenterResume: TypeDefinition = { id: 4, name: "CareerCenterResume" };

    public static Values: TypeDefinition[] = [
        SEOPageType.Page,
        SEOPageType.Event,
        SEOPageType.CareerCenterJobPost,
        SEOPageType.CareerCenterResume,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/SEOPageType.ts